import { api } from '@config/api';
import type { Notificacao } from '@/types/api';

export const notificacaoService = {
  list: () => api.get<Notificacao[]>('/me/notifications').then((r) => r.data),
  marcarLida: (id: string) =>
    api.patch<Notificacao>(`/notifications/${id}/read`).then((r) => r.data),
};
